/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import "./style.scss";
import React from "react";
import Heading from "../../components/Heading";
import HubsList from "./HubList/Hublist";
import { useLocation } from "react-router-dom";

const Hubs = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const type = params.get("type");

  return (
    <div className="p-1">
      <Heading title={`Hubs - ${type === "ECOMM" ? "Ecomm" : "Cargo"}`} />
      <div className="global-card-tab-container">
        <HubsList />
      </div>
    </div>
  );
};

export default Hubs;
